import { useSelector } from "react-redux"

export const useGetLoggedInUserDetails = () => {

    const loggedInUser = useSelector((state) => state?.auth?.authenticatedUserSlice?.loggedInUserDetails)

    return {
        loggedInUser
    }
}